import Calendar from "@/components/DayCalendar";
import { CrewNavigation } from "@/components/Crew/tabs";
interface DispatchProps {
  onDate?: Date;
}

export function Dispatch({ onDate = new Date() }: DispatchProps) {
  return (
    <>
      <div className="px-6 py-2">
        <CrewNavigation />
      </div>
      <div className="px-6 py-2">
        <h1 className="text-2xl font-bold">Dispatch</h1>
        <Calendar onDate={onDate} dispatchMode />;
      </div>
    </>
  );
}
